import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { InteractionsModel } from '../models/interactions/interactionsModel';
import AuthService from './authService';
import { DrugToDrugInteractionModel } from '../models/drugToDrugInteractionModel';
import { DrugToDiseaseInteraction } from '../models/drugToDiseaseInteraction';
import { DrugToFoodAlcoholInteraction } from '../models/drugToFoodAlcoholInteraction';
import { ProfessionType, PregnancyType } from '../common/enums';

class InteractionsService {

  authService = new AuthService();
  lang = '';

  constructor(lang?) {
    this.lang = lang;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Pragma: 'no-cache',
      "langId": HelperFunctions.getLangId(lang)
    }
  }

  getUserMedicines(userId: number, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getUserMedicines/${userId}`,
      method: 'get',
      headers: {
        Authorization: `Bearer ${this.authService.getToken()}`,
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getUserDiseases(userId: number, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getUserDiseases/${userId}`,
      method: 'get',
      headers: {
        Authorization: `Bearer ${this.authService.getToken()}`,
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getMedicineInteractions(interactions: InteractionsModel, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getMedicineInteractions/`,
      method: 'post',
      data: JSON.stringify(interactions),
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDrugToDrugInteraction(interactions: DrugToDrugInteractionModel, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getDrugToDrugInteraction/`,
      method: 'post',
      data: JSON.stringify(interactions),
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDrugToDiseaseInteraction(interactions: DrugToDiseaseInteraction, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getDrugToDiseaseInteraction/`,
      method: 'post',
      data: JSON.stringify(interactions),
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDrugToFooodInteraction(interactions: DrugToFoodAlcoholInteraction, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getDrugToFoodInteraction/`,
      method: 'post',
      data: JSON.stringify(interactions),
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDrugToPregnancyInteraction(medicineId: number, pregnancyType: boolean, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getDrugToPregnancyInteraction/${medicineId}/${pregnancyType}`,
      method: 'post',
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getDrugToProffesionInteraction(medicineId: number, professionType: boolean, lang: string) {
    return axios({
      url: `${Constants.apiUrl}/interactions/getDrugToProffesionInteraction/${medicineId}/${professionType}`,
      method: 'post',
      headers: {
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default InteractionsService;